//firebase.js
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

// Конфигурация из Firebase Console (замени на свою)
const firebaseConfig = {
    apiKey : "AIzaSyCEdy9qFvj-GAzwDPa1vF190QtwRLTnwcg" , 
    authDomain : "mesds-a2607.firebaseapp.com" , 
    projectId : "mesds-a2607" , 
    storageBucket : "mesds-a2607.firebasestorage.app" , 
    messagingSenderId : "828998811823" , 
    appId : "1:828998811823:web:4346f8ce43d2da0dd3945a" , 
    measurementId : "G-RN5XM7MV0N"
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

// Запрос разрешения и получение токена
export const requestFirebaseToken = async () => {
    try {               
        if (Notification.permission !== 'granted') {
            console.log('Notification permission denied');
            return null;
        }
       
        // Получаем токен
        const token = await getToken(messaging, {
            vapidKey: "BGG7RXsvRYWV-sT7cZSIx5HEQoBdu4J4BRqOHEpFIAgkgWfmli6rx1NeIeiDKtFgBgDBhRwE7jt1O7f71LVd6aE", // Из Firebase Console → Project Settings → Cloud Messaging
           
        });        
       if (token) return token;
    } catch (error) {
        console.error('Error getting Firebase token:', error);
        return null;
    }
};

// Обработка входящих push-уведомлений (когда приложение открыто)
export const onFirebaseMessage = (callback) => {
    onMessage(messaging, (payload) => {       
        callback(payload);
    });
};

export default messaging;